import React from "react";
import { Redirect, Route, Switch } from "react-router";

import { buildUrl } from "misc/helpfunctions";
import { clientUrls } from "misc/urls";

import BmBatteriesComponent from "../components/BmBatteriesComponent";
import BmOverviewComponent from "../components/BmOverviewComponent";

const BmContainer = () => {
    return (
        <Switch>
            <Route exact path={clientUrls.modules.bm.overview()}>
                <BmOverviewComponent />
            </Route>

            <Route exact path={clientUrls.modules.bm.batteries()}>
                <BmBatteriesComponent />
            </Route>

            <Route
                exact
                path={clientUrls.modules.bm.batteryDetail()}
                render={({ match }) => (
                    <Redirect
                        to={buildUrl({
                            path: clientUrls.modules.bm.batteries(),
                            queryParameters: {
                                view: "battery-view",
                                battery: match.params.batteryId
                            }
                        })}
                    />
                )}
            />

            <Redirect to={clientUrls.modules.bm.batteries()} />
        </Switch>
    );
};

export default BmContainer;
